import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AlertCircle, Home, RotateCcw } from 'lucide-react';

export function AuthError() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const error = searchParams.get('error') || 'unknown';

    const getErrorMessage = (errorType: string) => {
        switch (errorType) {
            case 'verification_failed':
                return 'Email verification failed. The link may be expired or invalid.';
            case 'google_oauth_failed':
                return 'Google authentication failed. Please try again.';
            case 'signup_failed':
                return 'Account creation failed. Please try again.';
            case 'login_failed':
                return 'Login failed. Please sign up first or check your credentials.';
            default:
                return 'An authentication error occurred. Please try again.';
        }
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center p-4">
            <div className="max-w-md w-full text-center space-y-6">
                <AlertCircle className="w-16 h-16 text-destructive mx-auto" />

                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-foreground">Authentication Error</h1>
                    <p className="text-muted-foreground">{getErrorMessage(error)}</p>
                </div>

                <div className="flex flex-col sm:flex-row gap-3 justify-center">
                    <button
                        onClick={() => navigate('/login')}
                        className="flex items-center justify-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
                    >
                        <RotateCcw className="w-4 h-4" />
                        Try Again
                    </button>

                    {/* <button
                        onClick={() => navigate('/')}
                        className="flex items-center justify-center gap-2 px-4 py-2 border border-border rounded-md hover:bg-accent transition-colors"
                    >
                        <Home className="w-4 h-4" />
                        Go Home
                    </button> */}
                </div>
            </div>
        </div>
    );
}